module.exports = __webpack_public_path__ + "img/LemonDecor.c94b052a.png";